var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVideoOffDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 18.9324H14.1669L0.1595 4.50108C0.0552903 4.76571 0.00115177 5.04842 0 5.33399V16.666C0 17.9159 0.9867 18.9324 2.2 18.9324ZM17.6 5.33399C17.6 4.08406 16.6133 3.06758 15.4 3.06758H4.8554L1.8777 0L0.3223 1.60235L20.1223 22L21.6777 20.3976L17.6 16.1969V12.889L22 16.666V5.33399L17.6 9.11095V5.33399Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoOffDefault);
export default __webpack_public_path__ + "static/media/ic-video-off-default.7e85acd91a077f4b618e6b7d9e47dee4.svg";
export { ForwardRef as ReactComponent };